module.exports = __webpack_public_path__ + "static/imagen_03-540ba739a7fb60d7974f366d692c32ce.jpg";